module.exports = __webpack_public_path__ + "img/icon_order_detail_active.d35a1f91.png";